import { render, staticRenderFns } from "./WalletsTotal.vue?vue&type=template&id=19b7e542"
import script from "./WalletsTotal.vue?vue&type=script&lang=js"
export * from "./WalletsTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports